module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "快递鸟",
      "name": "kdniao"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "EBusinessID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.kdniao_form.config.EBusinessID),
      callback: function($$v) {
        _vm.$set(_vm.kdniao_form.config, "EBusinessID", $$v)
      },
      expression: "kdniao_form.config.EBusinessID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "AppKey"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.kdniao_form.config.appkey),
      callback: function($$v) {
        _vm.$set(_vm.kdniao_form.config, "appkey", $$v)
      },
      expression: "kdniao_form.config.appkey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.kdniao_form.config.is_open),
      callback: function($$v) {
        _vm.$set(_vm.kdniao_form.config, "is_open", $$v)
      },
      expression: "kdniao_form.config.is_open"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "快递100",
      "name": "kuaidi100"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Key"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.form.config.app_key),
      callback: function($$v) {
        _vm.$set(_vm.form.config, "app_key", $$v)
      },
      expression: "form.config.app_key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.form.config.app_secret),
      callback: function($$v) {
        _vm.$set(_vm.form.config, "app_secret", $$v)
      },
      expression: "form.config.app_secret"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.config.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form.config, "is_open", $$v)
      },
      expression: "form.config.is_open"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-618a34bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-618a34bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/kdniao.vue
// module id = 2768
// module chunks = 0